'use client';

import { Trans, t } from '@lingui/macro';
import { Box, Container, Stack, Typography } from '@mui/material';
import { AppPalettes, Button, PageHeader } from '@prismo-io/design-system';
import Image from 'next/image';
import Link from 'next/link';
import type { FC } from 'react';
import DefaultQuarkLogo from '@/assets/aura/app/primary/common/icone-quark.svg';
import quarkImg from '@/assets/quark-temp/app/no-result.svg';
import backgroundImg from '@/assets/quark-temp/backgrounds/no-result.png';
import { useLingui } from '@lingui/react';
import { ThemeProvider } from '@prismo-io/design-system/theme-provider';
import { Application, translate } from '@prismo-io/router';
import { LanguageCode, type LanguageCodeT } from '@prismo-io/schemas';
type Props = unknown;
const buildQuestionnaireUrl = (locale: LanguageCodeT) => {
  // eslint-disable-next-line no-constant-condition, prettier/prettier
  return translate({
    app: Application.QUARK,
    path: `/`,
    addHostname: true,
    locale
  });
};
export const QuarkNoResult: FC<Props> = () => {
  const {
    i18n
  } = useLingui();
  const {
    locale = LanguageCode.Enum.fr
  } = i18n;
  const questionnaireUrl = buildQuestionnaireUrl(locale as LanguageCodeT);
  const quarkTitle = <>
      <Typography color="white" fontSize={{
      none: '1.10rem',
      sm: '1.25rem',
      md: '1.75rem'
    }} fontWeight="bolder">
        Quark
      </Typography>
      <Typography color="white" fontSize={{
      none: '1.10rem',
      sm: '1.25rem',
      md: '1.75rem'
    }}>
        |
      </Typography>
      <Typography color="white" fontSize={{
      none: '1.10rem',
      sm: '1.25rem',
      md: '1.75rem'
    }}>
        {t`Compétences`}
      </Typography>
    </>;
  return <ThemeProvider theme={AppPalettes.light} options={{
    key: 'quark-no-result'
  }} data-sentry-element="ThemeProvider" data-sentry-component="QuarkNoResult" data-sentry-source-file="index.tsx">
      <Box position="relative" width="100%" height="100vh" component="section" overflow="hidden" data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Box component="div" position="absolute" top="0" bottom="0" right="0" left="0" data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <Image src={backgroundImg} alt="" style={{
          objectFit: 'cover',
          objectPosition: 'center'
        }} fill data-sentry-element="Image" data-sentry-source-file="index.tsx" />
        </Box>
        <PageHeader pageImg={DefaultQuarkLogo} pageTitleRender={quarkTitle} data-sentry-element="PageHeader" data-sentry-source-file="index.tsx" />
        <Box component="div" height="100%" py={{
        none: '1.5rem',
        sm: '2rem',
        lg: '4rem',
        xl: '6rem'
      }} overflow="auto" data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <Container maxWidth="sm" data-sentry-element="Container" data-sentry-source-file="index.tsx">
            <Stack position="relative" direction="column" alignItems="center" spacing={4} data-sentry-element="Stack" data-sentry-source-file="index.tsx">
              <Box component="div" position="relative" width="100%" height={{
              none: '10rem',
              sm: '15rem'
            }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
                <Image src={quarkImg} alt="" style={{
                objectFit: 'contain',
                objectPosition: 'center'
              }} fill data-sentry-element="Image" data-sentry-source-file="index.tsx" />
              </Box>
              <Typography variant="h2" fontSize="1.5rem" lineHeight="2rem" textAlign="center" color="primary.main" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
                <Trans data-sentry-element="Trans" data-sentry-source-file="index.tsx">Vous aussi découvrez vos domaines d’expertise !</Trans>
              </Typography>
              <Stack justifyContent="center" data-sentry-element="Stack" data-sentry-source-file="index.tsx">
                <Button LinkComponent={Link} href={questionnaireUrl} variant="contained" color="gradient" sx={{
                '& .MuiButton-startIcon': {
                  display: 'none'
                }
              }} data-sentry-element="Button" data-sentry-source-file="index.tsx">
                  <Trans data-sentry-element="Trans" data-sentry-source-file="index.tsx">Passez Quark dès maintenant</Trans>
                </Button>
              </Stack>
              <Typography fontSize="1.5rem" color="white" textAlign="center" lineHeight="2rem" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
                <Trans data-sentry-element="Trans" data-sentry-source-file="index.tsx">
                  Renseignez vos expériences et vos formations et identifiez vos
                  compétences techniques à partir d’une sélection sûr mesure.
                </Trans>
              </Typography>
            </Stack>
          </Container>
        </Box>
      </Box>
    </ThemeProvider>;
};